import React from 'react';
import { Gem, Crown, Plus, RefreshCw } from 'lucide-react';
import Button from './ui/Button';

const TokenBalanceCard = ({
  tokens = 0,
  isVip = false,
  onBuy,
  onVip,
  onRefresh,
  buyLabel = 'Comprar',
}) => (
  <div className="mb-6 flex items-center justify-between rounded-2xl border border-white/10 bg-zinc-900 p-5">
    <div className="flex items-center gap-4">
      <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-rose-500/15">
        <Gem className="h-6 w-6 text-rose-400" />
      </div>
      <div>
        <p className="text-2xl font-bold leading-none text-white">{tokens}</p>
        <p className="mt-1 text-sm text-zinc-400">Tokens disponíveis</p>
      </div>
    </div>
    <div className="flex flex-col items-end gap-2">
      {onBuy && (
        <Button onClick={onBuy} icon={Plus} size="sm">
          {buyLabel}
        </Button>
      )}
      {onRefresh && (
        <Button onClick={onRefresh} icon={RefreshCw} size="sm" variant="secondary">
          Atualizar
        </Button>
      )}
      {!isVip && onVip && (
        <Button onClick={onVip} variant="premium" size="sm" icon={Crown}>
          VIP
        </Button>
      )}
    </div>
  </div>
);

export default TokenBalanceCard;
